export function resolveOtpNavigation({
  via,
  phone,
  twoFaSetup,
  twoFaRequired,
}) {
  if (phone) {
    return { step: "2", path: "/confirm-otp", twoFaSetup: phone };
  }

  if (via === "phone" && (twoFaSetup === "null" || !twoFaSetup)) {
    return { step: "1", path: "/setup-otp" };
  }

  if (via === "phone" || via === "email") {
    return { step: "2.2", path: "/verify-otp" };
  }

  if (twoFaSetup === "null" && twoFaRequired === "false") {
    return { step: false, path: "/dashboard" };
  }

  return null;
}
